<template>
  <div class="display-ticket-item-wrapper" @click="() => handlePurchase(value.id)">
    <van-image
      lazy-load
      fit="cover"
      class="avatar-wrapper"
      :width="107"
      :height="60"
      :src="value.logo"
    />
    <div class="content-wrapper">
      <p class="title">{{ value.title }}</p>
      <p class="price">
        <span class="icon">￥</span>
        <span>{{ `${value.price || '0.00'} ` }}</span>
        <span class="start">起</span>
      </p>
      <p class="desc">
        <van-icon name="location-o" />
        <span>{{ `${value.province} - ${value.city}` }}</span>
      </p>
    </div>
    <div class="action-wrapper" v-if="navigationEnabled">
      <p class="distance">距您 {{ value.distance }} 千米</p>
      <van-button type="primary" size="small" @click.stop="onOpenNavigation">导航去这里</van-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [Object],
    navigationEnabled: [Boolean],
  },
  methods: {
    handlePurchase(id) {
      this.$emit('click', id);
    },
    onOpenNavigation() {
      const { title: name, lat, lng, address } = this.value;
      this.$emit('navigate', {
        name,
        address,
        latitude: parseFloat(lat),
        longitude: parseFloat(lng),
      });
    },
  },
};
</script>
<style lang="less" scoped>
.display-ticket-item-wrapper {
  &:not(:last-child) {
    border-bottom: 1px dashed #eee;
  }
  display: flex;
  align-items: stretch;
  padding: 16px;
  .avatar-wrapper {
    margin-right: 12px;
    border-radius: 4px;
    overflow: hidden;
  }
  .content-wrapper {
    flex: 1;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    text-align: left;
    .title {
      font-weight: bold;
      margin-bottom: 8px;
    }
    .price {
      color: #faad14;
      .icon,
      .start {
        font-size: 80%;
      }
      .start {
        color: #ccc;
      }
    }
    .desc {
      color: #858b9c;
      font-size: 70%;
      margin-top: 6px;
      display: flex;
      align-items: center;
    }
  }
  .action-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    .distance {
      color: #858b9c;
      font-size: 70%;
      display: flex;
      align-items: center;
    }
  }
}
</style>
